import * as React from "react"
import "./style_6.scss"
import { careData } from "../../constants";

export default function ProductContentStyle6({ items, title }) {
    return (
        <div>
            <div className="product-content title">{ title }</div>
            {(items?.map((data, index) => {
                const careSymbols = data?.care_symbols?.map(item => careData?.find(data => item === data?.icon));

                return !!Object.keys(data)?.length && (
                    <div key={index}
                        className={`product-content style_6`}
                    >
                        <div className={`content-block-info`}>
                            {data.style === 'care_type' ? (
                                <div className="care-icons">
                                    {!!careSymbols?.length && careSymbols?.map((item, itemIndex) => (
                                        <i key={itemIndex} className={`icon icon-${item?.icon}`} />
                                    ))}
                                </div>
                            ) : (
                                <div className="instructions">
                                    <div className="inner-circle">
                                        <img src={data.icon} alt="" />
                                    </div>
                                    <div className="info">
                                        <p className="title">{data.title}</p>
                                        <p className="description">{data.info}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )
            }))}
        </div>
    );
}
